module.exports = __webpack_public_path__ + "static/sound-illustration-ee64221cf157dfdbf994e284e2faa35f.mp4";